import React from 'react';

import PlaceholderTab from '~/components/Offers/Detail/OfferBuilder/shared/PlaceholderTab';

import { OVERRIDE_FIELDS } from './fields';

export default function OverridesTab() {
  return <PlaceholderTab configuredFieldCount={OVERRIDE_FIELDS.length} title="Overrides" />;
}
